export default __webpack_public_path__ + "static/media/dixhuit.7bdb54aa.png";